import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';
import 'primeicons/primeicons.css';

import './WebApp/Css/index.css';
import './WebApp/Css/responsive.css';
import './WebApp/Css/primereact.css';

import { Provider } from 'react-redux';
import { store } from './WebApp/Controllers/Store';
import { PersistGate } from "redux-persist/integration/react";
import StripeProvider from './WebApp/Authentication/StripeProvider';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <StripeProvider>
      <App />
    </StripeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
